// src/utils/envValidation.js
export const validateEnv = () => {
    const required = [
      'REACT_APP_AWS_REGION',
      'REACT_APP_GAME_SAVE_INTERVAL',
      'REACT_APP_MAX_CHECKPOINTS'
    ];
  
    const missing = required.filter(
      key => !process.env[key]
    );
  
    if (missing.length > 0) {
      throw new Error(
        `Missing required environment variables: ${missing.join(', ')}`
      );
    }
  };